import React from "react";
import PropTypes from "prop-types";

import { Grid } from "react-flexbox-grid/lib/index";

import { MuiThemeProvider } from "@material-ui/core/styles";
import BaseRouter from "app/ui/components/BaseRouter";
import RequireLogin from "components/RequireLogin";
import RebuildStatus from "components/RebuildStatus";
import ErrorModal from "components/ErrorModal";
import NavDrawer from "./NavDrawer";
import Header from "./Header";
import { prodTheme, devTheme, styles } from "./styles";

const headerStyle = drawerOpen => {
  if (drawerOpen) return { ...styles.header, ...styles.drawer };
  return styles.header;
};
const contentStyle = drawerOpen => {
  if (drawerOpen) return { ...styles.content, ...styles.drawer };
  return styles.content;
};

const BaseLayout = props => {
  return (
    <MuiThemeProvider
      theme={props.mode === "production" ? prodTheme : devTheme}
    >
      <Grid fluid>
        {/* Error modal */}
        <ErrorModal {...props} type="Error" />
        {/* App bar header */}
        <div style={headerStyle(props.renderDrawer && props.appDrawerOpen)}>
          <Header {...props} />
        </div>
        {/* Nav drawer */}
        {props.renderDrawer && <NavDrawer {...props} />}

        <div style={contentStyle(props.renderDrawer && props.appDrawerOpen)}>
          {/* Block additional component rendering until logged in */}
          <RequireLogin {...props}>
            {/* Block additional component rendering until workarea selected */}

            {/* Add main content by url using react-router */}
            <RebuildStatus {...props}>
              {/* Additionally block BaseRouter if rebuild is running */}
              <BaseRouter {...props} />
            </RebuildStatus>
          </RequireLogin>
        </div>
      </Grid>
    </MuiThemeProvider>
  );
};
BaseLayout.defaultProps = { userEmail: "" };

BaseLayout.propTypes = {
  mode: PropTypes.string.isRequired,
  renderDrawer: PropTypes.bool.isRequired,
  appDrawerOpen: PropTypes.bool.isRequired,
  userEmail: PropTypes.string
};
export default BaseLayout;
